import {
    Box,
    Typography,
    Switch,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { CookieCategory } from "../cookieTypes";
import { CookieTable } from "./cookieTable";

interface CategorySettingsProps {
    category: CookieCategory;
    checked: boolean;
    onToggle: () => void;
}

export const CategorySettings: React.FC<CategorySettingsProps> = ({
    category,
    checked,
    onToggle
}) => {
    const hasCookies = category.cookies.length > 0;

    return (
        <Box>
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        onChange={onToggle}
                        disabled={category.required}
                    />
                }
                label={
                    <Box>
                        <Typography fontWeight={600}>
                            {category.name}
                            {hasCookies && (
                                <Typography
                                    component="span"
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ ml: 1 }}
                                >
                                    ({category.cookies.length})
                                </Typography>
                            )}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {category.description}
                        </Typography>
                    </Box>
                }
            />

            {hasCookies && (
                <Accordion sx={{ mt: 1, ml: 4 }} elevation={0}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant="body2" color="primary">
                            Details anzeigen
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <CookieTable cookies={category.cookies} compact />
                    </AccordionDetails>
                </Accordion>
            )}
        </Box>
    );
};